module.exports = __webpack_public_path__ + "img/strap_length.a5604c54.png";